import React, { useState } from 'react';
import { useLoading } from "../../../../../../hooks/LoadingHook";
import { useModal } from "../../../../../../hooks/Modal";
import { useLanguage } from "../../../../../../hooks/Language";
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';
import { useParams } from 'react-router-dom';
import sleep from "../../../../../../utils/sleep";
import { useSocket } from '../../../../../../hooks/Socket';
import { useAuth } from '../../../../../../hooks/Auth';

type IPropsStatusConfirmation = 'waiting_confirmation' | 'processing' | 'error' | 'success';

export default function usePaymentRequest() {

    const { projectHash, eventHash } = useParams<Record<string, any>>();
    const { translate, language } = useLanguage();
    const { removeLoading, addLoading } = useLoading();
    const { socket } = useSocket();
    const { addModal } = useModal();
    const { addToast } = useToast();
    const { getTrackingRecommendation } = useAuth();

    const [requestStatus, setRequestStatus] = useState<IPropsStatusConfirmation>('waiting_confirmation')




    /* payment with 3 steps 
    1. Apply payment request status - waiting confirmation
    2. Confirm payment request - processing
    3. Finish - Success or Error
    
    */

    const paymentCheckStatus = {

        success: ({ message, sale_hash }) => {

            addLoading({ title: 'Compra confirmada. Você será redirecionado.', key: 'loading' });
            return window.location.href = `/app/${projectHash}/payment/success/${sale_hash}`;



        },
        error: ({ message, sale_hash }) => {

            addModal({ title: 'Ocorreu um problema ao gerenciar seu pedido', theme: 'whiteModalMini', content: <>{message}</> });

            return;

        }
    }


    const paymentRequest = async ({ paymentContext, moveToCart: moveToCartFunction }) => {

        let mainStatus = 'waiting';


        const limit = 300;

        removeLoading('loading');
        addLoading({ title: 'Enviando seu pedido', key: 'loading' })
        const { content, coupon, cart, paymentMethod } = paymentContext;


        socket?.off('checkout-status-message');
        socket?.on('checkout-status-message', (data) => {

            const { payment_status_id, message, sale_hash, moveToCart } = data;
            paymentCheckStatus?.[payment_status_id]({ message, sale_hash });
            mainStatus = payment_status_id;
            if (moveToCart === 'yes') {
                moveToCartFunction();
            }

        })

        const seller_hash = getTrackingRecommendation();

        if (seller_hash) {
            paymentContext.seller_hash = seller_hash;
        }

        await api
            .post(`/v3/apply-payment`, {
                ...paymentContext
            })
            .then(async response => {

                mainStatus = 'waiting_confirm';

                removeLoading('loading');
                addLoading({ title: 'Aguardando confirmação de disponibilidade', key: 'loading' });

                for (let i = 0; i < 300; i++) {

                    if (mainStatus === 'success' || mainStatus === 'error') {




                        break;
                    }

                    const checkCart = await api.get(`v3/get-my-sale-request/${response?.data?.sale_hash}`);

                    const { payment_status_id, message, sale_hash, moveToCart } = checkCart?.data;

                    if (payment_status_id === 'success' || payment_status_id === 'error') {

                        paymentCheckStatus?.[payment_status_id]({ message, sale_hash, moveToCart });
                        mainStatus = payment_status_id;

                        if (moveToCart === 'yes') {
                            moveToCartFunction();
                        }

                        removeLoading('loading');
                        break;
                    }
                    if (payment_status_id === 'processing') {


                        mainStatus = payment_status_id;
                        if (mainStatus !== payment_status_id) {
                            removeLoading('loading');
                            addLoading({ title: 'Seu pagamento está sendo processado', key: 'loading' })
                        }

                    }

                    if (i === limit) {
                        removeLoading('loading');
                        addToast({ title: 'Conexão interrompida', description: 'Entre em contato com o suporte.', type: 'error' })
                        break;
                    }


                    await sleep(1000); // aguarda por 1 segundo (1000 milissegundos)
                }

                removeLoading('loading');

            })
            .catch(err => {
                addModal({
                    title: translate('Erro'),
                    content: <>{translate(err?.response?.data?.message || err?.response?.data?.error || translate('Erro ao efetuar pagamento'))}</>,
                    theme: 'whiteModalMini'
                });
                removeLoading('loading')
                return false;
            });


    }

    return { paymentRequest };


}